//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {callApp, isApp, isWx, shareFun} from '@/util/const'
import shareDownload from '../shareDownload'

export default {
    components: {
        shareDownload
    },
    data () {
        return {
          lang:window.localStorage.getItem('lang')
        }
    },
    created () {
        shareFun({
            type: 1,
            url: `${location.origin}${location.pathname}#/luckyDraw`,
            title: `${this.$t('draw.c111')}`,
            img: `https://mylink.oss-accelerate.aliyuncs.com/mylinkH5/shareLogo/shareLogo`,
            content: `${this.$t('draw.c111')}`
        })
    },
    methods: {
      jump () {
        window.location.href = this.$t('draw.c110')
      },
      jumpTo (index) {
        window.location.href = this.$t('draw.c82')[index]
      },
        change (index) {
            this.prepare[index].show = !this.prepare[index].show
        },
        goto (num) {
            if (num === 1) {
                document.body.scrollTop = document.documentElement.scrollTop = document.querySelectorAll('.draw').offsetTop
            } else {
                document.body.scrollTop = document.documentElement.scrollTop = 100
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/page/greenchannel/luckyDraw.vue